/**
 * DeSight Shopify X | v1.0.0
 * Cross-Selling Module
 * 
 * Handles add-to-cart functionality for cross-selling products on PDP
 */

class CrossSellingManager {
  constructor() {
    this.forms = document.querySelectorAll('.cross-selling-product-form');
    this.init();
  }

  init() {
    if (this.forms.length === 0) return;

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.forms.forEach(form => {
      const productForm = form.querySelector('form[data-type="add-to-cart-form"]');
      if (!productForm) return;

      productForm.addEventListener('submit', (e) => this.handleSubmit(e, form));
    });
  }

  async handleSubmit(event, formWrapper) {
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const buttonText = submitButton.querySelector('span');
    const spinner = submitButton.querySelector('.loading__spinner');
    
    // Get form data
    const formData = new FormData(form);
    
    // Disable button and show loading
    submitButton.setAttribute('disabled', 'disabled');
    submitButton.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    try {
      // Add to cart
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.status === 422 || data.status === 'error') {
        // Handle error
        this.handleError(data, formWrapper, submitButton);
      } else {
        // Success
        this.handleSuccess(data, submitButton, buttonText);
      }
    } catch (error) {
      this.handleError({ message: 'Ein Fehler ist aufgetreten' }, formWrapper, submitButton);
    } finally {
      // Re-enable button
      submitButton.removeAttribute('disabled');
      submitButton.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  handleSuccess(data, button, buttonText) {
    // Publish cart update event (if using Shopify's pub/sub)
    if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'cross-selling',
        cartData: data
      });
    }

    // Update cart drawer/notification if exists
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    
    if (cartDrawer) {
      cartDrawer.renderContents(data);
    } else if (cartNotification) {
      cartNotification.renderContents(data);
    }

    // Visual feedback
    const originalText = buttonText.textContent;
    buttonText.textContent = '✓ Hinzugefügt';
    button.classList.add('button--success');

    setTimeout(() => {
      buttonText.textContent = originalText;
      button.classList.remove('button--success');
    }, 2000);
  }

  handleError(error, formWrapper, button) {
    const hideErrors = formWrapper.dataset.hideErrors === 'true';
    
    if (!hideErrors) {
      // Show error message
      let errorMessage = error.message || error.description || 'Ein Fehler ist aufgetreten';
      
      // Create or update error element
      let errorElement = formWrapper.querySelector('.cross-selling-error');
      if (!errorElement) {
        errorElement = document.createElement('div');
        errorElement.className = 'cross-selling-error';
        errorElement.style.cssText = 'color: rgb(var(--color-error, 255, 0, 0)); margin-top: 1rem; font-size: 1.4rem;';
        formWrapper.appendChild(errorElement);
      }
      
      errorElement.textContent = errorMessage;
      
      // Remove error after 5 seconds
      setTimeout(() => {
        if (errorElement) errorElement.remove();
      }, 5000);
    }

  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CrossSellingManager();
  });
} else {
  new CrossSellingManager();
}

// Re-initialize on Shopify section events (Theme Editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new CrossSellingManager();
  });
}



